var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashAltSolid = function SvgTrashAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4c-.523 0-1.059.184-1.437.563C13.183 4.94 13 5.477 13 6v1H7v2h1v16c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V9h1V7h-6V6c0-.523-.184-1.059-.562-1.437C20.058 4.183 19.523 4 19 4Zm0 2h4v1h-4Zm-5 3h14v16c0 .555-.445 1-1 1H11c-.555 0-1-.445-1-1Zm2 3v11h2V12Zm4 0v11h2V12Zm4 0v11h2V12Z"
  })));
};
export default SvgTrashAltSolid;